module.exports = __webpack_public_path__ + "img/stores.dc7ba936.svg";